import React, { useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RecoveryContext } from '../recoveryContext';
import { useStores } from 'hooks/useStores';
import {INVALIDATION_TIP, REGEX} from "../../../const/validation";

const schema = yup.object().shape({
	password: yup
		.string()
		.required(INVALIDATION_TIP.FIELD_REQUIRED)
		.min(8, INVALIDATION_TIP.MIN_LENGTH_PASSWORD)
		.max(16, INVALIDATION_TIP.MAX_LENGTH_PASSWORD)
		.matches(
			REGEX.VALID_PASSWORD,
			INVALIDATION_TIP.INCORRECT_PASSWORD
		),
	password2: yup
		.string()
		.oneOf([yup.ref('password'), null], INVALIDATION_TIP.MATCHES_PASSWORD )
		.required(INVALIDATION_TIP.FIELD_REQUIRED),
});

export default function RecoveryStep3(props) {
	const { contextEmail } = useContext(RecoveryContext);
  const { api } = useStores()

	const changeStep = () => {
		props.nextStep(4);
	};

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: 'onBlur',
		resolver: yupResolver(schema),
	});

	const onSubmit = data => {
    api.auth.postRestorePassword({
      email: contextEmail,
				new_password: data.password2,
    },)
		changeStep();
	};

	const [passwordShown, setPasswordShown] = useState(false);
	const togglePasswordVisiblity = () => {
		setPasswordShown(passwordShown ? false : true);
	};

	const [passwordShown2, setPasswordShown2] = useState(false);
	const togglePasswordVisiblity2 = () => {
		setPasswordShown2(passwordShown2 ? false : true);
	};
	return (
		<div>
			<h3 className='lkLogin-main__step'>Шаг 3</h3>
			<h1 className='lkLogin-main__title'>Восстановление</h1>
			<form className='lkLogin-form' onSubmit={handleSubmit(onSubmit)}>
				<div className='lkLogin-form-item'>
					<label htmlFor='password'>
						Новый пароль<span className='lkLogin-form__span'>*</span>
					</label>
					<input
						autoFocus
						{...register('password')}
						id='password'
						name='password'
						type={passwordShown ? 'text' : 'password'}
						className='lkLogin-input'
					/>
					<div
						className='lkLogin-showHide-pass'
						onClick={togglePasswordVisiblity}
					>
						{passwordShown ? <>скрыть</> : <>показать</>}
					</div>
					<p className='lkLogin-form__err'>{errors.password?.message}</p>
				</div>
				<div className='lkLogin-form-item'>
					<label htmlFor='password2'>
						Повторите новый пароль<span className='lkLogin-form__span'>*</span>
					</label>
					<input
						{...register('password2')}
						id='password2'
						name='password2'
						type={passwordShown2 ? 'text' : 'password'}
						className='lkLogin-input'
					/>
					<div
						className='lkLogin-showHide-pass'
						onClick={togglePasswordVisiblity2}
					>
						{passwordShown2 ? <>скрыть</> : <>показать</>}
					</div>
					<p className='lkLogin-form__err'>{errors.password2?.message}</p>
				</div>
				<div>
					<button className='lkLogin-form-btn lkLogin-form-item' type='submit'>
						Далее
					</button>
				</div>
			</form>
		</div>
	);
}
